import React, { useState } from "react";
import { Box, Card, Divider, Grid, Tab, Paper, Container } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import CommonTabs from "src/components/CommonTabs/CommonTabs";
import TabHeader from "src/components/TabHeader/TabHeader";
import { SettingsRoute } from "src/modules/settings/setting.routes";
import { useStyles } from "./components/style";
import { AddTerminal } from "./components/addTerminal/addTerminal";

function a11yProps(index: any) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

type Props = {};

export default function Terminal({}: Props): React.ReactElement {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const moduleName = SettingsRoute.title;
  const pageHeading = "Terminals";

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} link={SettingsRoute.path} />
      <Box mt={1} mb={2}></Box>
      <Box m={2} />
      <Grid container direction="row">
        <Grid item xs={12} md={12} className={classes.cardMainParent}>
          <Paper elevation={3} className={classes.cardMain}>
            <Grid container>
              <AddTerminal value={value} index={0} />
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}
